const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Scroll Bottom component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */

app.directive('scrollBottom', [function () {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      element.bind('click', function() {
        window.scrollTo(0,document.body.scrollHeight);
      });
    }
  };
}]);
